export default __webpack_public_path__ + "static/impact4-0183c35da56a3b9260a69a5655d1a331.png";